<template>
	<div class="malloms-payload">

		<div class="pitem">
			<template v-for="(item,idx) in pageItem" >
				<div class="ptitle">{{item.label}}</div>
				<van-cell>
					<template slot="icon">
						<van-image
							class="pimage"
							width="100"
							height="60"
							:src="item.image"
						/>
					</template>
					<template slot="title">
						{{item.title}}
					</template>
					<template slot="label">
						{{formatTime(item.startTime)}} / {{formatTime(item.endTime)}}
					</template>
					<template slot="right-icon">
						<div class="pright">
							<!-- <div>
								<van-icon 
									v-if="idx == 0"
									class="selected" 
									name="circle" 
									size="20px"
									color="#909399"
								/>
									<van-icon 
									v-if="idx == 1"
									class="selected" 
									name="passed" 
									size="20px" 
									color="#67C23A"
								/>
							</div> -->

							<van-tag 
								class="send"
								type="primary"
								size="medium"
								@click="handleSend(idx)"
							> 发送 </van-tag>

						</div>
					</template>
				</van-cell>
			</template>
		</div>

		<!--分享弹框-->
		<van-popup 
			v-model="send.show" 
			position="bottom" 
			:style="{ height: '60vh' }" 

		>
			<div class="send-payload">
				<div class="title">请选择发送方式</div>
				<div class="content">
					<!-- <van-row>
						<van-col :span="12">
							<div class="thalf">
								<div class="stext">
									<div class="stitle">{{send.text.title}}</div>
									<div class="slink">{{send.text.url}}</div>
								</div>
							</div>
						</van-col>
						<van-col :span="12"> -->
							<div class="thalf onehalf">
								<div class="tmini">
									<div class="ttitle">{{send.mini.title}}</div>
									
									<van-image
										class="timage"
										width="150"
										height="150"
										:src="send.mini.image"
									/>
								</div>
							</div>
						<!-- </van-col>
					</van-row> -->
				</div>
				<van-tabbar v-model="send.type">
					<!-- <van-tabbar-item icon="link-o" @click="handlClickShare('text')">发送文字链接</van-tabbar-item> -->
					<van-tabbar-item icon="miniprogram-o" @click="handlClickShare('mini')">发送小程序</van-tabbar-item>
				</van-tabbar>
			</div>
		</van-popup>
	</div>
</template>

<script type="text/javascript">
import {wxminiCfg} from '@/config/wxmini';
import {getQwSignature} from '@/interface/qywx/qwglobal';

import {lottery, invite, signin} from '@/interface/oms/operate/active';
export default {
	data(){
		return {
			//企业微信签名信息
			qywxCfg: {
				agentId: '',
				corpId: '',
				url: '',
				corpTimestamp: '',
				corpNonceStr: '',
				corpSignature: '',
				agentTimestamp: '',
				agentNonceStr: '',
				agentSignature: '',
			},
			qywxCurrent:{
				thirdCode:'qywx',	//来源
				chatId: '',		//当前群ID
				agent: 'oms',	//当前应用
			},
			querys:{
			},
			send:{
				type: '',
				show: false,
				currentIdx: '',
				text:{
					title: '',
					url: ''
				},
				mini:{
					title: '',
					image: ''
				}	
			},
			pageItem:[]
		}
	},
	created: function() {
		this.getQywxCfg();
		this.getLottery();
		this.getInvite();
		this.getSignin();
	},
	methods:{
		handleSend: function(idx){
			let current = this.pageItem[idx];

			let title = current.title;

			this.send.text = {
				title: title,
				url: '分享短连接',
			}

			let url = '';
			if( current.key == 'lottery' ){
				//抽奖
				url = 'ppages/oms/lottery/detail/detail.html';
			}else if( current.key == 'signin' ){
				//签到
				url = 'ppages/oms/signin/detail/detail.html';
			}else if( current.key == 'invite' ){
				//邀请好友
				url = 'ppages/oms/invite/detail/detail.html';
			}

			this.send.mini = {
				title: title,
				image: current.image,
				url: url
			}

			this.send.currentIdx = idx;
			this.send.show = true;
		},
		handlClickShare: function(type){
			if( type == 'mini' ){
				let miniData = {
					title: this.send.mini.title,
					imgUrl: this.send.mini.image,
					page: this.send.mini.url
				}

				this.sendMiniProgram( miniData );
				this.send.show = false;
			}
		},
		getLottery: function(){
			lottery()
				.then(res=>{
					if( res.status && ('id' in res.response) ){
						let info = res.response;
						let row = {
							label: '抽奖活动',
							key: 'lottery',
							id: info.id,
							title: info.title,
							startTime: info.startTime,
							endTime: info.endTime,
							image: info.adsImg,
						}

						this.pageItem.push(row);
					}
				})
				.catch(err=>{})
		},
		getSignin: function(){
			signin()
				.then(res=>{
					if( res.status && ('id' in res.response) ){
						let info = res.response;
						let row = {
							label: '每日签到',
							key: 'signin',
							id: info.id,
							title: info.title,
							startTime: info.startTime,
							endTime: info.endTime,
							image: info.adsImg,
						}

						this.pageItem.push(row);
					}
				})
				.catch(err=>{})
		},
		getInvite: function(){
			invite()
				.then(res=>{
					if( res.status && ('id' in res.response) ){
						let info = res.response;
						let row = {
							label: '邀请好友',
							key: 'invite',
							id: info.id,
							title: info.title,
							startTime: info.startTime,
							endTime: info.endTime,
							image: info.adsImg,
						}

						this.pageItem.push(row);
					}
				})
				.catch(err=>{})
		},
		formatTime: function(dt){
			return dt.substr(0,10);
		},
		//获取企业微信签名信息
		getQywxCfg: function(){
			let data = {
				app: 'oms',
				url: window.location.href.split('#')[0],
			}

			getQwSignature(data)
				.then( res=>{
					let info = res.response;
					this.qywxCfg = {
						corpId: info.corpId,
						agentId: info.agentId,
						url: info.url,
						corpSignature: info.corpSignature,
						corpTimestamp: info.corpTimestamp,
						corpNonceStr: info.corpNonceStr,
						agentSignature: info.agentSignature,
						agentTimestamp: info.agentTimestamp,
						agentNonceStr: info.agentNonceStr,
					}

					this.qywxInit();
				})
				.catch( err=>{

				})
		},
		//企业微信初始化
		qywxInit: function(){
			let _this = this;

			ww.register({
				corpId: _this.qywxCfg.corpId,       // 必填，当前用户企业所属企业ID
				agentId: _this.qywxCfg.agentId,  // 必填，当前应用的AgentID
				jsApiList: ['getContext','getCurExternalChat','sendChatMessage'], // 必填，需要使用的JSAPI列表
				getConfigSignature,
				getAgentConfigSignature,            // 必填，根据url生成应用签名的回调函数
				onConfigSuccess(res){
					// alert('configSuccess:'+JSON.stringify(res));
				},
				onConfigFail(res){
					alert('企业签名获取失败:'+JSON.stringify(res));
				},
				onConfigComplete(res){
					// alert('configComplete:'+JSON.stringify(res));
				},
				onAgentConfigFail(res){
					alert('应用签名获取失败:'+JSON.stringify(res));
				},          
				onAgentConfigComplete(res){
					// alert('onAgentConfigComplete:'+JSON.stringify(res));
				}				
			})

    		// 根据 url 生成企业签名
			async function getConfigSignature(url) {
				// alert( 'getConfigSignature:'+JSON.stringify(_this.qywxCfg) );
				
				return {
					timestamp: _this.qywxCfg.corpTimestamp,
					nonceStr: _this.qywxCfg.corpNonceStr,
					signature: _this.qywxCfg.corpSignature
				};
			}

			// 根据 url 生成应用签名，生成方法同上，但需要使用应用的 jsapi_ticket
			async function getAgentConfigSignature(url) {
				// alert( 'getAgentConfigSignature:'+JSON.stringify(_this.qywxCfg) );

				return { 
					timestamp: _this.qywxCfg.agentTimestamp,
					nonceStr: _this.qywxCfg.agentNonceStr,
					signature: _this.qywxCfg.agentSignature
				};
			}

			//获取当前群ID
			this.handleCurExternalChat();
		},
		//获取当前群ID
		handleCurExternalChat: function(){
			let _this = this;
			ww.getCurExternalChat({
				success(res){
					_this.qywxCurrent.chatId = res.chatId;
				},
				fail(err){
					alert('群ID获取失败:'+JSON.stringify(res));
				},
				complete: function(res){
					// alert('ExternalChat-complete:'+JSON.stringify(res));
				}
			})
		},
		/**
		 *分享小程序
		 *@param map miniData 小程序参数
		 *			title: 	标题
		 *			imageUrl 图片路径，以.html结尾
		 *			page:   跳转路径
		 */
		sendMiniProgram: function(miniData){
			let pageUrl = miniData.page;
				pageUrl+= '?thirdCode='+this.qywxCurrent.thirdCode;
				pageUrl+= '&agent='+this.qywxCurrent.agent;
				pageUrl+= '&chatId='+this.qywxCurrent.chatId;

			ww.sendChatMessage({
				msgtype: 'miniprogram',
				miniprogram: {
					appid: wxminiCfg.newClient.appId,
					title: miniData.title,
					imgUrl: miniData.imgUrl,
					page: pageUrl,
				},
				success(res){
					// alert('小程序发送成功:'+JSON.stringify(res));
				},
				fail(err){
					// alert('小程序发送失败:'+JSON.stringify(res));
				},
				complete: function(res){
					// alert('handleMiniProgram-complete:'+JSON.stringify(res));
				}
			})
		},
	}
}
</script>